export enum Intervals {
  DAY = 'by_day',
  WEEK = 'by_week',
  MONTH = 'by_month',
}
